import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ContactsAddModalComponent } from 'src/app/contacts/contacts-add-modal/contacts-add-modal.component';
import { ContactState } from 'src/app/contacts/contacts.state';
import { ContactPerson } from 'src/app/models/ContactPerson';

@Component({
    selector: 'app-link-contacts-autocomplete',
    templateUrl: './link-contacts-autocomplete.component.html',
    styleUrls: ['./link-contacts-autocomplete.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class LinkContactsAutocompleteComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    /* 
    This is the reuseable component to link a contactPerson to another entity in a form. 

    To make this work you need to pass the form(group) in which this component will be used.
    Make sure the formcontrolName in the form is set to 'contactPerson' !
    
    If you need to preselect a contactperson you pass it (obj) to the initialValue variable.
 */

    @Select(ContactState.Contacts) contacts$: Observable<ContactPerson[]>;

    @Input() form: UntypedFormGroup;
    @Input() initialValue: any = '';

    contacts: ContactPerson[];
    contactKeyword = 'fullName';

    constructor(private modalService: NgbModal) {}

    ngOnInit(): void {
        this.subscriptions.add(this.contacts$.subscribe((contacts: ContactPerson[]) => (this.contacts = contacts)));
    }

    openAddContactPersonModal() {
        const modalRef = this.modalService.open(ContactsAddModalComponent, {
            windowClass: 'modal-pane',
            animation: false,
        });
        modalRef.componentInstance.linkContactModal = true;
        this.subscriptions.add(modalRef.componentInstance.fullNameFilter.subscribe((newContactFullName) => (this.initialValue = newContactFullName)));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
